import { apiGet } from "../baseApi";
import { setTagIcon } from "service/mapper";
import { isValidValue } from "utils";


export const getIconList = async (params) => {
  try {
    const response = await apiGet("_tagIcon", params);
    if (!isValidValue(response.data)) {
      response.data = [];
    }
    return { ...response, data: (Array.isArray(response.data) ? response.data : []).map((el) => setTagIcon(el)) };
  } catch (error) {
    return Promise.reject(error);
  }
};
